import { Link } from "react-router-dom";
import { constants } from "../constant/constants";

export const roundNumber = (number, devMul = 100) => {
  return Math.round((Number(number || 0) + Number.EPSILON) * devMul) / devMul;
};

export function convertTo12hr(time24) {
  if (!Boolean(time24)) {
    return "";
  }

  const [hrs, mins] = time24.split(":").map(Number);
  const period = hrs >= 12 ? "PM" : "AM";
  const hrs12 = hrs % 12 || 12;
  return `${String(hrs12)}:${String(mins).padStart(2, "0")} ${period}`;
}

export const makeCamelCase = (value) => {
  return String(value).charAt(0).toUpperCase() + String(value).slice(1);
};

export const getOrderStatusColor = (status) => {
  let color =
    status === "pending"
      ? "#EE3169"
      : status === "ongoing"
        ? "#0284C7"
        : status === "prepared"
          ? "#0000FF"
          : status === "delivered"
            ? "#2EC12B"
            : status === "completed"
              ? "#2EC12B"
              : "#808080";

  return color;
};

export const getStatusColor = (status) => {
  let color = status === "Pending" ? "#DC2626" : status === "Published" ? "#2EC12B" : "#EE3169";
  return color;
};

export const getFoodStatusColor = (status) => {
  let color = status === "active" ? "#2EC12B" : "#EE3169";
  return color;
};

export const getStaffStatusColor = (status) => {
  const s = status.toLowerCase();
  return s === "on" ? "#2EC12B" : s === "off" ? "#696969" : "#EE3169";
};

export const getRestaurantStatusColor = (status) => {
  let color = status === "Pending" ? "#FCBD10" : status === "Published" ? "#2EC12B" : "#EE3169";
  return color;
};

export const redirectTo = (url) => {
  window.open(url, "_blank").focus();
};

export const getOptionSelectedValueOf = (field, record, selectedIndex = 0) => {
  if (record.param && record.param.options && record.param.options[selectedIndex]) {
    return roundNumber(record.param.options[selectedIndex][field]).toFixed(2);
  }

  return "0.00";
};

export const getOfferText = (price, discount, isDiscountInPercent = false) => {
  const hasDiscount = discount > 0;

  if (hasDiscount && isDiscountInPercent) {
    discount = roundNumber((price * discount) / 100);
  }

  return hasDiscount ? (
    <div className="flex flex-row font-uregular">
      <div className="mr-[4px]">{`Offer Price -  ${roundNumber(price - discount).toFixed(2)} TK`}</div>
      <div className="ml-[4px] line-through">{`${price} TK`}</div>
    </div>
  ) : (
    ""
  );
};

export const isAuthorize = (menus, ignoreCommonMenus = true) => {
  let lastPath = window.location.href.slice(window.location.href.lastIndexOf("/") + 1);
  if (ignoreCommonMenus) {
    let ignoreMenus = Object.values(constants.IGNORE_MENU);
    if (ignoreMenus.includes(lastPath)) {
      return true;
    }
  }

  return menus.includes(makeCamelCase(lastPath));
};

export const getStructuredQueryParam = (params) => {
  let queryParam = "";
  Object.entries(params).map(([key, value], index) => {
    if (index == 0) {
      queryParam += "?";
    } else {
      queryParam += "&";
    }
    queryParam += `${key}=${encodeURIComponent(value)}`;
  });
  return queryParam;
};

export const getFormatForDateFormat = (date) => {
  if (!date) {
    return "";
  }

  let dt = new Date(date);

  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).format(dt);
};

export const formatDisplayDateTime = (dateTimeStr = "", isNeededTime = true, isAmPm = true) => {
  if (!Boolean(dateTimeStr)) {
    return "";
  }
  const date = new Date(dateTimeStr);
  const options = {
    year: "numeric",
    month: "short", // Short month format (e.g., Nov)
    day: "2-digit",
  };

  if (isNeededTime) {
    options["hour"] = "2-digit";
    options["minute"] = "2-digit";
    options["hour12"] = isAmPm;
  }

  return date.toLocaleString("en-US", options);
};

export const getRawDateTime24 = (date) => {
  if (!date) {
    return "";
  }

  let dt = new Date(date);
  return `${dt.getFullYear()}-${dt.getMonth() + 1}-${dt
    .getDate()
    .toString()
    .padStart(2, "0")} ${dt.getHours().toString().padStart(2, "0")}:${dt.getMinutes().toString().padStart(2, "0")}`;
};

export const showCookingTimeField = (order) => {
  return order.status == "waiting";
};

export const convertBase64ToBlob = (base64, imageName = "foodImage") => {
  if (base64 && typeof base64.getCroppedCanvas === "function" && typeof base64.replace === "function") {
    base64 = base64.getCroppedCanvas().toDataURL();
  }

  const mimeTypeMatch = base64.match(/^data:(image\/[a-zA-Z]*);base64,/);

  if (!mimeTypeMatch) {
    throw new Error("Unable to detect MIME type from the base64 string.");
  }

  const mimeType = mimeTypeMatch[1];
  const base64Data = base64.split(",")[1];
  const byteCharacters = atob(base64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset++) {
    byteArrays.push(byteCharacters.charCodeAt(offset));
  }

  const ext = mimeType.substring(mimeType.indexOf("/") + 1);

  const blob = new Blob([new Uint8Array(byteArrays)], { type: mimeType });
  return new File([blob], `${imageName}.` + ext, { type: mimeType });
};

/**
 * It will return full path of an image if path provided otherwise it will return relative path of the provided default image
 *
 * @param {*} filePath
 * @param {*} defaultFilePath
 * @returns
 */
export const serverImgFullPath = (filePath, defaultFilePath = "") => {
  return Boolean(filePath) ? filePath : defaultFilePath;
};

export const validatePhoneNumber = (phoneNo) => {
  if (!phoneNo || phoneNo.length < 10) {
    return false;
  }

  const lastTenDigits = phoneNo.trim().slice(-10);
  const regex = /^(?:\+88|88)?(01[3-9]\d{8})$/;

  return regex.test("880" + lastTenDigits);
};

export const calculateRefundOrDue = (refundLogs) => {
  const filteredLogs = refundLogs?.filter((log) => !log.isRefunded);
  const totalAmount = Number(filteredLogs?.reduce((total, log) => total + log.refundAmount, 0)).toFixed(2);

  if (totalAmount > 0) {
    return {
      amount: totalAmount,
      status: "Refund",
      colorCode: "#2EC12B",
      button: "Refund",
    };
  } else {
    return {
      amount: totalAmount,
      status: "Due",
      colorCode: "#EE3169",
      button: "Clear Dues",
    };
  }
};

export const getParsedNumber = (val) => {
  const num = parseFloat(val);
  return isNaN(num) ? 0 : num;
};

export const hasMoreData = (page = 1, perPage = 10, total = 10) => {
  const pageNo = getParsedNumber(page);
  const perPageData = getParsedNumber(perPage);
  const totalRecords = getParsedNumber(total);

  const totalReceived = pageNo * perPageData;

  return totalRecords > totalReceived;
};

export const getCurrentDate = () => {
  let today = new Date();

  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(today.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const validateFileType = (file) => {
  const validExtensions = ["image/jpeg", "image/png", "image/jpg", "image/webp"];

  if (!validExtensions.includes(file.type)) {
    return "Only JPG, PNG, and WebP images are allowed.";
  }

  return "";
};

/**
 *
 * @param {*} context OFFER_IMAGE
 * @param {*} width
 * @param {*} height
 */
export const validateImageDimension = (context, width, height) => {
  if (context === "FOOD_IMAGE" && (width < 500 || height < 500)) {
    return "Minimum dimension of banner image 500 X 500.";
  }

  if (context === "BANNER_IMAGE" && (width < 500 || height < 500)) {
    return "Minimum dimension of banner image 500 X 500.";
  }

  if (context === "OFFER_IMAGE" && (width < 500 || height < 300)) {
    return "Minimum dimension of offer image 530 X 300.";
  }

  return "";
};

export const getOtpRemainingTime = () => {
  let otpVerifyObj = localStorage.getItem("otpVerifyObj");

  if (!otpVerifyObj) {
    return 0;
  }

  otpVerifyObj = JSON.parse(otpVerifyObj);

  const otpSendingTime = parseInt(otpVerifyObj.otpSendingTime);
  let timeRemaining = parseInt(new Date().getTime() / 1000);
  timeRemaining = timeRemaining - otpSendingTime;

  if (timeRemaining > 118) {
    return 0;
  }

  // 1 sec loading time estimated
  return 118 - timeRemaining + 1;
};

export const storeOtpVerifyObj = (phone) => {
  localStorage.setItem(
    "otpVerifyObj",
    JSON.stringify({
      phone: phone,
      otpSendingTime: parseInt(new Date().getTime() / 1000),
    }),
  );
};

export const retrieveOtpVerifyObj = () => {
  const defaultObj = { phone: "", otpSendingTime: 0 };

  const otpVerifyObj = localStorage.getItem("otpVerifyObj");

  if (!otpVerifyObj) {
    return defaultObj;
  }

  return JSON.parse(otpVerifyObj);
};

export const formatMenus = (menus) => {
  return menus.map((item) => {
    item.children = item?.children || [];

    const formatedMenus = {
      label: <Link to={`${item.link}`}>{item.label}</Link>,
      icon: item.icon,
      key: item.key,
    };

    if (item.children.length > 0) {
      formatedMenus.children = item.children.map((subItem) => ({
        label: <Link to={`${subItem.link}`}>{subItem.label}</Link>,
        icon: subItem.icon,
        key: subItem.key,
      }));
    }

    return formatedMenus;
  });
};

/**
 * It compares two arrays which contains literals not json
 *
 * @param {*} arr1 array of literals
 * @param {*} arr2 array of literals
 * @returns
 */
export function isSameTwoArrays(arr1, arr2) {
  if (arr1.length !== arr2.length) return false;

  const sorted1 = [...arr1].sort();
  const sorted2 = [...arr2].sort();

  return sorted1.every((val, index) => val === sorted2[index]);
}

/**
 * Checks if the given string contains at least one alphabetic character (A-Z or a-z).
 *
 * @param {string} str - The string to check for alphabetic characters.
 * @returns {boolean} Returns true if the string contains at least one alphabetic character, otherwise false.
 */
export function containsAlphabet(str) {
  return /[A-Za-z]/.test(str);
}

export function isDate1GreaterThanDate2(date1, date2) {
  if (!date1 || !date2) {
    return false;
  }

  const d1 = new Date(date1).getTime();
  const d2 = new Date(date2).getTime();

  if (isNaN(d1) || isNaN(d2)) {
    return false;
  }

  return d1 > d2;
}

// Check if only special characters
export const isOnlySpecialCharacters = (value) => {
  return /^[^a-zA-Z0-9]+$/.test(value.trim());
};

/**
 * Session storage is tab specific. This method get the stored id which is considered as session id or tab id.
 * The session id is actually order id or an unique UUID.
 *
 *
 * @param {*} orderId
 * @returns
 */
export function getOrCreateSessionId(orderId = "") {
  const key = "app:tab_id";
  let tabId = sessionStorage.getItem(key);

  if (!tabId) {
    tabId = crypto.randomUUID();
    sessionStorage.setItem(key, tabId);
  }

  return tabId;
}

export function removeSessionId() {
  const key = "app:tab_id";
  sessionStorage.setItem(key, "");
}

export function storeOrderedFoodsInSession(orderedFoods) {
  const key = "app:orderedFoods";
  sessionStorage.setItem(key, JSON.stringify(orderedFoods.foods));
}

export function getStoredFoodsFromSession() {
  const key = "app:orderedFoods";
  const foods = sessionStorage.getItem(key);

  return foods ? JSON.parse(foods) : [];
}

export function getOptionName(optionName) {
  return ["Default", "System Default"].includes(optionName) ? "" : optionName;
}

export function getBasePriceFromIncludedPrice(includedPrice, includedItemPercentage) {
  const divisor = 1 + includedItemPercentage / 100;
  const base = includedPrice / divisor;

  return base;
}

/**
 * 
 * @param {*} sdScIncludedPrice 
 * @param {*} scPercent 
 * @param {*} sdPercent 
 * @returns {Object} {
    basePrice,
    serviceCharge,
    supplementaryDuty,
  }
 */
export const extractScSd = (sdScIncludedPrice, scPercent, sdPercent) => {
  if (sdScIncludedPrice <= 0) {
    return { basePrice: 0, serviceCharge: 0, supplementaryDuty: 0 };
  }

  let scRate = scPercent / 100;
  let sdRate = sdPercent / 100;

  const basePrice = sdScIncludedPrice / (1 + scRate + sdRate);

  const serviceCharge = basePrice * scRate;
  const supplementaryDuty = basePrice * sdRate;

  return {
    basePrice,
    serviceCharge,
    supplementaryDuty,
  };
};
